import script from "./verify.vue?vue&type=script&setup=true&lang=js"
export * from "./verify.vue?vue&type=script&setup=true&lang=js"

import "./verify.vue?vue&type=style&index=0&id=7c7bd291&lang=scss"

const __exports__ = script;

export default __exports__